import React from "react"
import {AllowedWalletsTermsColumns} from "./WalletTerms.types"
import {WalletTerms} from "../../resources/walletTerms"
import {Resource} from "../../resources/common"
import {Meta} from "../../resources/common"
import {DataTable, DataTableHead, DataTableBody, DataTableCell, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import WalletTermsRow from "./WalletTermsRow"

interface WalletTermsTableProps {
	walletsTerms: WalletTerms[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedWalletsTermsColumns[]
	meta?: Meta
	refresh?: () => void
	fullHeight?: boolean
}

export default function WalletTermsTable({
	walletsTerms,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	meta,
	prev,
	next,
	include,
}: WalletTermsTableProps) {
	const noContent = walletsTerms.length === 0
	return (
		<div className={"wallet-terms-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText={"No wallets terms found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{walletsTerms.map((p) => (
						<WalletTermsRow key={p.id} include={include} includedColumns={includedColumns} walletTerms={p} />
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
